import { forwardRef } from 'react';

import type { ReactNode, RefObject } from 'react';

import type { AriaPopoverProps } from '@react-aria/overlays';
import type { OverlayTriggerState } from '@react-stately/overlays';

import { DismissButton, Overlay, usePopover } from '@react-aria/overlays';

import { Box } from '@simplywallst/ui-core';

interface Props
  extends Pick<AriaPopoverProps, 'triggerRef' | 'isNonModal' | 'placement'> {
  children: ReactNode;
  state: OverlayTriggerState;
}

const PREFIX_WIDTH = 49; // 49 is the width of prefix with the border

export const Popover = forwardRef<HTMLDivElement, Props>(
  ({ children, state, triggerRef, isNonModal, placement }, ref) => {
    const { popoverProps } = usePopover(
      {
        triggerRef,
        isNonModal,
        placement,
        popoverRef: ref as RefObject<HTMLDivElement>,
        crossOffset: -PREFIX_WIDTH,
      },
      state
    );

    return (
      <Overlay>
        <Box
          {...popoverProps}
          ref={ref}
          style={{
            ...popoverProps.style,
          }}
          width={
            (triggerRef.current?.getBoundingClientRect().width ?? 0) +
            PREFIX_WIDTH
          }
        >
          {children}
          <DismissButton onDismiss={state.close} />
        </Box>
      </Overlay>
    );
  }
);

Popover.displayName = 'Popover';
